import { Typography } from '@material-tailwind/react'
import PropTypes from 'prop-types'

export const InputHelperText = ({ label, color }) => {
  return (
    <Typography
      variant="small"
      color={color}
      className="mt-2 font-normal"
    >
      {label}
    </Typography>
  )
}

InputHelperText.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string
}

InputHelperText.defaultProps = {
  color: 'gray'
}
